import { Pipe, PipeTransform } from '@angular/core';
import {PtyWsService} from "../services/pty-ws.service";
const md5 = require('md5');

@Pipe({
  name: 'translation'
})
export class TranslationPipe implements PipeTransform {
  translation: any;
  default = {};
  isUsingDefault = true;

  constructor(
      private ws: PtyWsService
  ) {
    this.default = require('../../assets/i18n/en.json');
    this.setTranslation();
  }

  setTranslation(){
    if (localStorage.getItem('app_translation')) {
      const data = localStorage.getItem('app_translation');
      this.translation = JSON.parse(data);
      this.translation = {...this.default, ...this.translation};
      this.isUsingDefault = false;
    } else {
      this.translation = this.default;
    }
  }

  /* check to see if this.translation matches what is currently in localstorage app_translation */
  languageMatches(){
    let currentLanguageStr =  JSON.stringify(this.translation);
    let localStorageStr = localStorage.getItem('app_translation');
    return currentLanguageStr === localStorageStr;
  }

  hasCachedTranslations() {
    return !!localStorage.getItem('app_translation');
  }

  transform(value: any, args?: any): any {
    // first, sets translation to whatever is in localstorage.
    // args param checks to see if locale has changed.  if locale has changed, args=true and translation gets reset
    // usage in app.component.html {{ p.title | translation:localeChanged }}
    // this.localeChanged is set at app.component.ts
    //
    if (this.isUsingDefault || args) {
      this.setTranslation();
    }

    if (!this.languageMatches() && this.hasCachedTranslations()) {
      const data = localStorage.getItem('app_translation');
      this.translation = JSON.parse(data);
      this.translation = {...this.default, ...this.translation};
      localStorage.setItem('app_translation', JSON.stringify(this.translation));
      this.isUsingDefault = false;
    }

    let translation = 'N/A';
    if (this.translation.hasOwnProperty(value)) {
      return this.translation[value];
    }

    const hash = md5(value);
    if (this.translation.hasOwnProperty(hash)) {
      return this.translation[hash];
    }

    const data = {
      phrase: value,
      category: null,     // TODO: Add phrase categories
    };
    this.translation[hash] = value;
    localStorage.setItem('app_translation', JSON.stringify(this.translation));
    this.ws.invokeURL('add_phrase', data).subscribe(() => {}, () => {});      // Don't care about return value, just inserting to db

    return value;
  }
}
